import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from '../pages/Home';
import Notification from '../pages/Notification';
import SearchResult from '../pages/SearchResult';
import AllOrder from '../pages/AllOrder';
import HelpSupport from '../pages/HelpSupport';
import RestaurantsSearch from '../pages/RestaurantsSearch';
import OrderSummary from '../pages/OrderSummary';
import GroupOrder from '../pages/GroupOrder';
import GroupOrderGuest from '../pages/GroupOrderGuest';
import KitchenRegistrationPage from '../pages/KitchenRegistrationPage';
import ProtectedRoute from '../components/ProtectedRoute';
import Cuisines from '../pages/DishList';

// Lazy import pages (can be added later)
// For now using placeholder pages
const Login = () => <div>Login Page</div>;
const Register = () => <div>Register Page</div>;
const Profile = () => <div>Profile Page</div>;
const RestaurantDetail = () => <div>Restaurant Detail Page</div>;
const Cart = () => <div>Cart Page</div>;
const Checkout = () => <div>Checkout Page</div>;
const Orders = () => <div>Orders Page</div>;
const OrderDetail = () => <div>Order Detail Page</div>;
const NotFound = () => <div>404 - Page Not Found</div>;

const AppRoutes = () => {
  // You can check auth status here
  const isAuthenticated = !!localStorage.getItem('kitchenAuthToken');

  return (
    <Routes>
      {/* Kitchen Registration Route - Not Protected */}
      <Route path="/kitchen-registration" element={<KitchenRegistrationPage />} />

      {/* Protected Routes - Require Kitchen Registration */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        }
      />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route
        path="/restaurants"
        element={
          <ProtectedRoute>
            <RestaurantsSearch />
          </ProtectedRoute>
        }
      />
      <Route
        path="/restaurants/:id"
        element={
          <ProtectedRoute>
            <RestaurantDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path="/notification"
        element={
          <ProtectedRoute>
            <Notification />
          </ProtectedRoute>
        }
      />
      <Route
        path="/result"
        element={
          <ProtectedRoute>
            <SearchResult />
          </ProtectedRoute>
        }
      />
      <Route
        path="/help-and-support"
        element={
          <ProtectedRoute>
            <HelpSupport />
          </ProtectedRoute>
        }
      />
      <Route
        path="/orders"
        element={
          <ProtectedRoute>
            <AllOrder />
          </ProtectedRoute>
        }
      />
      <Route
        path="/order-summary"
        element={
          <ProtectedRoute>
            <OrderSummary />
          </ProtectedRoute>
        }
      />
      <Route
        path="/group-order"
        element={
          <ProtectedRoute>
            <GroupOrder />
          </ProtectedRoute>
        }
      />
      <Route path="/group-order-guest" element={<GroupOrderGuest />} />
      <Route
        path="/dish"
        element={
          <ProtectedRoute>
            <Cuisines />
          </ProtectedRoute>
        }
      />

      {/* Protected Routes */}
      {isAuthenticated ? (
        <>
          <Route path="/profile" element={<Profile />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/orders/:id" element={<OrderDetail />} />
        </>
      ) : (
        <Route path="/profile" element={<Navigate to="/login" />} />
      )}

      {/* 404 Route */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
